const DataPointMapper = {
  toTableData: performanceItemDataPoint => ({
    id: performanceItemDataPoint.Id,
    measurementName: performanceItemDataPoint.CheckpointPerformanceItems.MeasurementName,
    upperLimit: performanceItemDataPoint.UpperLimit,
    lowerLimit: performanceItemDataPoint.LowerLimit,
    actual: performanceItemDataPoint.Actual,
    notes: performanceItemDataPoint.Notes,
    status: performanceItemDataPoint.Status
  }),
  toViewPage: performanceItemDataPoint => ({
    measurementName: performanceItemDataPoint.CheckpointPerformanceItems.MeasurementName,
    measurementDescription:
      performanceItemDataPoint.CheckpointPerformanceItems.MeasurementDescription,
    measurementCalculation:
      performanceItemDataPoint.CheckpointPerformanceItems.MeasurementCalculation,
    measurementUnit: performanceItemDataPoint.CheckpointPerformanceItems.MeasurementUnit,
    numerator: performanceItemDataPoint.CheckpointPerformanceItems.Numerator,
    denominator: performanceItemDataPoint.CheckpointPerformanceItems.Denominator,
    targetDescription: performanceItemDataPoint.CheckpointPerformanceItems.TargetDescription,
    goodPerformanceIndicator:
      performanceItemDataPoint.CheckpointPerformanceItems.GoodPerformanceIndicator,
    timeBounds: performanceItemDataPoint.CheckpointPerformanceItems.TimeBounds,
    timeFrame: performanceItemDataPoint.CheckpointPerformanceItems.TimeFrame,
    captureFrequency: performanceItemDataPoint.CheckpointPerformanceItems.CaptureFrequency,
    reportFrequency: performanceItemDataPoint.CheckpointPerformanceItems.ReportFrequency,
    measurementLevel: performanceItemDataPoint.CheckpointPerformanceItems.MeasurementLevel,
    measurementUse: performanceItemDataPoint.CheckpointPerformanceItems.MeasurementUse,
    limitationsOrBlindSpots:
      performanceItemDataPoint.CheckpointPerformanceItems.LimitationsOrBlindSpots,
    qualityDomain: performanceItemDataPoint.CheckpointPerformanceItems.QualityDomain,
    customQualityDomainDefinition:
      performanceItemDataPoint.CheckpointPerformanceItems.CustomQualityDomainDefinition,
    businessObjective: performanceItemDataPoint.CheckpointPerformanceItems.BusinessObjective,
    qualityObjective: performanceItemDataPoint.CheckpointPerformanceItems.QualityObjective,
    isDiscontinued: performanceItemDataPoint.CheckpointPerformanceItems.IsDiscontinued,
    discontinuedReason: performanceItemDataPoint.CheckpointPerformanceItems.DiscontinuedReason,
    upperLimit: performanceItemDataPoint.UpperLimit,
    lowerLimit: performanceItemDataPoint.LowerLimit,
    actual: performanceItemDataPoint.Actual,
    notes: performanceItemDataPoint.Notes,
    status: performanceItemDataPoint.Status
  })
};

export default DataPointMapper;
